import {
  Filter,
  FilterClearBtn,
  FilterLabel,
  FilterOptionItem,
  FilterOptionsList,
  FilterPlaceholder,
  FilterTrigger,
  FilterValue,
} from '@src/design-system/filter';
import { formatTextForDisplay } from '@src/shared/utils/helpers/format-text-for-display';
import { REMINDER_TEMPLATE_CONTENT_TYPES } from '@src/shared/types/reminder-template';
import type { TTempFilters } from './';

export function ReminderContentTypeFilter({
  tempFilters,
  setTempFilters,
}: {
  tempFilters: TTempFilters;
  setTempFilters: (filters: TTempFilters) => void;
}) {
  return (
    <Filter
      multiple={false}
      value={tempFilters.content_type}
      onValueChange={(value) =>
        setTempFilters({
          ...tempFilters,
          content_type: value,
        })
      }
    >
      <div className='w-full flex items-center justify-between'>
        <FilterLabel>Type</FilterLabel>
        <FilterClearBtn />
      </div>
      <FilterTrigger>
        <FilterPlaceholder>Select Type</FilterPlaceholder>
        <FilterValue />
      </FilterTrigger>
      <FilterOptionsList>
        {Object.values(REMINDER_TEMPLATE_CONTENT_TYPES).map((type) => (
          <FilterOptionItem
            value={type}
            key={type}
          >
            <span>{formatTextForDisplay(type)}</span>
          </FilterOptionItem>
        ))}
      </FilterOptionsList>
    </Filter>
  );
}
